import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/sections/Hero";
import Opportunity from "@/components/sections/Opportunity";
import HowItWorks from "@/components/sections/HowItWorks";
import WhereAndHow from "@/components/sections/WhereAndHow";
import LRSWindow from "@/components/sections/LRSWindow";
import Philosophy from "@/components/sections/Philosophy";
import WhyUs from "@/components/sections/WhyUs";
import GetStarted from "@/components/sections/GetStarted";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import { SectionDivider } from "@/components/SectionDivider";

const LandingPage = () => {
  return (
    <main data-testid="landing-page" className="bg-[#080808] text-[#F8F6F0] min-h-screen">
      <Header />
      <Hero />
      <SectionDivider />
      <Opportunity />
      <SectionDivider />
      <HowItWorks />
      <SectionDivider />
      <WhereAndHow />
      <SectionDivider />
      <LRSWindow />
      <SectionDivider />
      <Philosophy />
      <SectionDivider />
      <WhyUs />
      <SectionDivider />
      <GetStarted />
      <SectionDivider />
      <Contact />
      <Footer />
    </main>
  );
};

export default LandingPage;
